import { COWindowComm } from "@3cad/nextcore";
// import { isDebuggerStatement } from "typescript";
import Vue from "vue";

export default {
    data() {
        return {
        };
    },
    methods: {
        lay_registerStoreModule(){
            //alert('register');
            this.$store.registerModule("layedit", {
                namespaced: true,
                state: {
                    layeditProfile: null,
                    layerActiveCatalog: null,
                    nextCOCommInstance: null,
                },
                getters: {
                    layeditProfile(state){
                        return state.layeditProfile;
                    },
                    layerActiveCatalog(state) {
                        return state.layerActiveCatalog;
                    },
                    nextCOCommInstance(state) {
                        return state.nextCOCommInstance;
                    },
                },
                mutations: {
                    layeditProfile(state,profile){
                        state.layeditProfile = profile;
                    },
                    layerActiveCatalog(state,catalog) {
                        state.layerActiveCatalog = catalog;
                    },
                    nextCOCommInstance(state, coWindowComm) {
                        state.nextCOCommInstance = coWindowComm;
                    }
                }
            });
        },
        lay_startCommunication(){
            //alert('start')
            var layeditComm = new COWindowComm("child");
            layeditComm.init()
                .then(data=>{
                    console.log(data)
                    this.$store.commit('layedit/nextCOCommInstance', layeditComm);
                    this.$store.getters['layedit/nextCOCommInstance'].reciveMessage((data,error)=>{
                        //alert(data.message)
                        if(error){
                            console.error(error)
                        }else{
                            console.log(data)
                            switch(data.message){
                                case 'loadCatalog':
                                    this.lay_loadCatalog(data.data.catalog)
                                    break;
                                default:
                                    break;
                            }
                        }
                    });
                })
                .catch(error=>{
                    console.error(error)
                });  

            /** Example of message receiving
             this.$store.getters['layedit/nextCOCommInstance'].reciveMessage((data,error)=>{
                        if(error){
                            console.warn(error);
                        }else{
                            switch (data.message) {
                            case 'myMessage':
                                    //do something with {data.data}
                                break;
                            default:
                                break;
                            } 
                        }  
                    })
             */
        },
        lay_receiveMessage(){
            return new Promise((resolve,reject)=>{
                this.$store.getters['layedit/nextCOCommInstance'].reciveMessage((data,error)=>{
                    if(error){
                        console.error(error);
                        reject(error) 
                    }else{
                        console.log(data)
                        resolve(data)
                    }  
                }); 
            })
        },
        lay_sendMessage(message,data = null){
            if(this.$store.getters['layedit/nextCOCommInstance']){
                this.$store.getters['layedit/nextCOCommInstance'].sendMessage(message,data);
            }else{
                console.error("ERROR: error while tryin to send data to Layedit Window. no Window.")
            }
        },
        lay_loadCatalog(layeditActiveCatalog){
            //alert('loadCatalog')
            //TEMP: metodo che carica il catalogo direttamente
            let iCatalog= layeditActiveCatalog.name;
            //create new project
            this.$store.commit("project/empty");
            this.$store.commit("erp/reset");
            // Register article search module
            if(!this.$store.state.searchArticle){
                this.$store.registerModule("searchArticle", {
                    namespaced: true,
                    state: {
                        breadcrumb: []
                    },
                    getters: {
                        getLast(state) {
                            return state.breadcrumb[state.breadcrumb.length - 1];
                        }
                    },
                    mutations: {
                        addNav(state, obj) {
                            state.breadcrumb.push(obj);
                        },
                        spliceNav(state, i) {
                            state.breadcrumb.splice(i + 1, state.breadcrumb.length);
                        }
                    }
                });
            }
            this.$store.commit("searchArticle/addNav", {
                mode: 1,
                des: iCatalog,
                data: {
                    des: iCatalog,
                    cod: iCatalog,
                    tip: "C"
                }
            });
            this.go("itemsearch");
        }
    }
};



// WEBPACK FOOTER //
// ./src/configurator/comp/mixins/layedit.js